<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33398 3.33331V7.49998H3.81858M16.6157 9.16665C16.2057 5.87805 13.4003 3.33331 10.0007 3.33331C7.20284 3.33331 4.80756 5.05679 3.81858 7.49998M3.81858 7.49998H7.50065M16.6673 16.6666V12.5H16.1827M16.1827 12.5C15.1937 14.9432 12.7985 16.6666 10.0007 16.6666C6.60097 16.6666 3.79564 14.1219 3.38556 10.8333M16.1827 12.5H12.5007"
      :stroke="color"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "20",
  },
  height: {
    type: [String, Number],
    default: "20",
  },
  color: {
    type: String,
    default: "#3B4648",
  },
  strokeWidth: {
    type: [String, Number],
    default: "2",
  },
});
</script>
